import { Component, OnInit } from '@angular/core';
import { OidcAuthService } from '@app/core/services/oidc-auth.service';
import { routes } from '@app/consts';
import { EnvironmentService } from "@app/core/services/environment.service";
import { CompanyLogosService } from '@app/modules/site-settings-styling/components/company-logos/services/company-logos.service';

@Component({
  selector: 'app-navigation',
  templateUrl: './navigation.component.html',
  styleUrls: ['./navigation.component.scss']
})
export class NavigationComponent implements OnInit {
  public user$: any;
  public routers: typeof routes = routes;

  constructor(
    private oidcAuthService: OidcAuthService,
    public environmentService: EnvironmentService,
    public companyLogosService: CompanyLogosService
  ) {
    this.user$ = this.oidcAuthService.userProfile;
  }

  ngOnInit(): void {
  }

  public signOut(): void {
    this.oidcAuthService.signout();
  }

}
